import { createStore } from "effector";
import { FetchRequestFx } from "../effects/FetchRequestFx";
import FetchResponseRdc from "../reducers/FetchResponseRdc";
import FTLSmartTableGate from "../gates/FTLSmartTableGate";
import OnStartFetchDataEvt from "../events/OnStartFetchDataEvt";
import OnStartFetchRdc from "../reducers/OnStartFetchRdc";
import FetchErrorRdc from "../reducers/FetchErrorRdc";
import OnChangeCurrentPageEvt from "../events/OnChangeCurrentPageEvt";
import ChangePageRdc from "../reducers/ChangePageRdc";
import OnChangePageSizeEvt from "../events/OnChangePageSizeEvt";
import ChangePageSizeRdc from "../reducers/ChangePageSizeRdc";
import OnChangeSearchParamsEvt from "../events/OnChangeSearchParamsEvt";
import ChangeSearchParamsRdc from "../reducers/ChangeSearchParamsRdc";
import OnChangeSearchParamEvt from "../events/OnChangeSearchParamEvt";
import ChangeSearchParamRdc from "../reducers/ChangeSearchParamRdc";
import ChangeSortRdc from "../reducers/ChangeSortRdc";
import OnChangeSortEvt from "../events/OnChangeSortEvt";
export default function FTLSmartTableStore(props) {
    const ftlSmartTableStore = createStore({
        classes: props.classes,
        page: 0,
        total: 0,
        rowsPerPage: 10,
        searchParams: props.searchParams ? props.searchParams : new Map(),
        metadata: props.metadata,
        data: [],
        isLoading: false,
        rowsPerPageOptions: props.rowsPerPageOptions ? props.rowsPerPageOptions : [5, 10, 20, 50],
    });
    const fetchRequestFX = FetchRequestFx(props.repo);
    const fetchResponseRdc = FetchResponseRdc();
    const fetchErrorRdc = FetchErrorRdc();
    const onStartFetchRdc = OnStartFetchRdc();
    const changePageSizeRdc = ChangePageSizeRdc();
    const changePageRdc = ChangePageRdc();
    const changeSearchParamsRdc = ChangeSearchParamsRdc();
    const changeSearchParamRdc = ChangeSearchParamRdc();
    const changeSortRdc = ChangeSortRdc();
    const onChangeCurrentPageEvt = OnChangeCurrentPageEvt();
    const onChangePageSizeEvt = OnChangePageSizeEvt();
    const onChangeSearchParamEvt = OnChangeSearchParamEvt();
    const onChangeSearchParamsEvt = OnChangeSearchParamsEvt();
    const onStartFetchDataEvt = OnStartFetchDataEvt();
    const onChangeSortEvt = OnChangeSortEvt();
    // Events
    ftlSmartTableStore.on(FTLSmartTableGate.open, onStartFetchRdc);
    ftlSmartTableStore.on(onStartFetchDataEvt, onStartFetchRdc);
    ftlSmartTableStore.on(onChangeCurrentPageEvt, changePageRdc);
    ftlSmartTableStore.on(onChangePageSizeEvt, changePageSizeRdc);
    ftlSmartTableStore.on(onChangeSearchParamsEvt, changeSearchParamsRdc);
    ftlSmartTableStore.on(onChangeSearchParamEvt, changeSearchParamRdc);
    ftlSmartTableStore.on(onChangeSortEvt, changeSortRdc);
    ftlSmartTableStore.watch(onChangeSearchParamsEvt, fetchRequestFX);
    ftlSmartTableStore.watch(onChangeSearchParamEvt, fetchRequestFX);
    ftlSmartTableStore.watch(onStartFetchDataEvt, fetchRequestFX);
    ftlSmartTableStore.watch(onChangeCurrentPageEvt, fetchRequestFX);
    ftlSmartTableStore.watch(onChangePageSizeEvt, fetchRequestFX);
    ftlSmartTableStore.watch(onChangeSortEvt, fetchRequestFX);
    ftlSmartTableStore.watch(FTLSmartTableGate.open, fetchRequestFX);
    ftlSmartTableStore.watch((state) => {
        console.log(state);
    });
    ftlSmartTableStore.on(fetchRequestFX.doneData, fetchResponseRdc);
    ftlSmartTableStore.on(fetchRequestFX.failData, fetchErrorRdc);
    return {
        gate: FTLSmartTableGate,
        store: ftlSmartTableStore,
        onStartFetchDataEvt: onStartFetchDataEvt,
        onChangePageSizeEvt: onChangePageSizeEvt,
        onChangeCurrentPageEvt: onChangeCurrentPageEvt,
        onChangeSearchParamsEvt: onChangeSearchParamsEvt,
        onChangeSearchParamEvt: onChangeSearchParamEvt,
        onChangeSortEvt: onChangeSortEvt,
        onFetchRequestFxDone: fetchRequestFX.doneData
    };
}
//# sourceMappingURL=FTLSmartTableStore.js.map